// 9fbef606107a605d69c0edbcd8029e5d
import {
  extractAttributeValue,
  getPLPProductAttributes,
  getProductAttributes,
  parseBoolean,
} from '@tcp/core/src/utils/badge.util';
import { isShopThisStoreModeOn } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import logger from '@tcp/core/src/utils/loggerInstance';
import { PRODUCT_BRAND_NAME_MAP } from '../../plpTileConstants';
import { getAPIConfig, getSessionStorage, setSessionStorage } from '../../../../../../utils';

export const getPdpUrl = ({
  seoToken,
  siteId,
  productPartNo,
  isBundleProduct,
  TCPPrimaryCategory,
  fromStoreDetailPage,
}) => {
  const stsSlug = isShopThisStoreModeOn() ? '&mode=shop-this-store' : '';
  const stsPart = isShopThisStoreModeOn() ? '?mode=shop-this-store' : '';
  const tcpPrimaryCategory = TCPPrimaryCategory ? `&tcpPrimaryCategory=${TCPPrimaryCategory}` : '';

  if (fromStoreDetailPage) {
    return {
      pdpUrl: {
        asPath: `/${siteId}/p/${seoToken || productPartNo}${stsPart}`,
        asPathWithoutSlug: `/p/${seoToken || productPartNo}${stsPart}`,
        href: `/p?pid=${
          seoToken || productPartNo
        }&fromStoreDetail=true${tcpPrimaryCategory}${stsSlug}`,
      },
    };
  }

  return isBundleProduct
    ? {
        pdpUrl: {
          asPath: `/${siteId}/b/${seoToken || productPartNo}${stsPart}`,
          asPathWithoutSlug: `/b/${seoToken || productPartNo}${stsPart}`,
          href: `/b?bid=${
            seoToken || productPartNo
          }&referer=categoryPage&dataSource=newplp${stsSlug}`,
        },
      }
    : {
        pdpUrl: {
          asPath: `/${siteId}/p/${seoToken || productPartNo}${stsPart}`,
          asPathWithoutSlug: `/p/${seoToken || productPartNo}${stsPart}`,
          href: `/p?pid=${
            seoToken || productPartNo
          }&referer=categoryPage&dataSource=newplp${tcpPrimaryCategory}${stsSlug}`,
        },
      };
};

export const getPdpUrlWithAlternateBrandSLP = ({
  seoToken,
  siteId,
  productPartNo,
  isBundleProduct,
  TCPPrimaryCategory,
  alternateBrand,
}) => {
  const stsSlug = isShopThisStoreModeOn() ? '&mode=shop-this-store' : '';
  const stsPart = isShopThisStoreModeOn() ? '?mode=shop-this-store' : '';
  const tcpPrimaryCategory = TCPPrimaryCategory ? `&tcpPrimaryCategory=${TCPPrimaryCategory}` : '';
  const tcpPrimaryBrand = alternateBrand ? `$brand=${alternateBrand}` : '';

  return isBundleProduct
    ? {
        pdpUrl: {
          asPath: `/${siteId}/b/${seoToken || productPartNo}${tcpPrimaryBrand}${stsPart}`,
          asPathWithoutSlug: `/b/${seoToken || productPartNo}${tcpPrimaryBrand}${stsPart}`,
          href: `/b?bid=${
            seoToken || productPartNo
          }&referer=searchPage&dataSource=newslp&isSearchPage=true${stsSlug}`,
        },
      }
    : {
        pdpUrl: {
          asPath: `/${siteId}/p/${seoToken || productPartNo}${tcpPrimaryBrand}${stsPart}`,
          asPathWithoutSlug: `/p/${seoToken || productPartNo}${tcpPrimaryBrand}${stsPart}`,
          href: `/p?pid=${
            seoToken || productPartNo
          }&referer=searchPage&dataSource=newslp&isSearchPage=true${tcpPrimaryCategory}${stsSlug}`,
        },
      };
};

export const isBundleProduct = (product) => {
  const { list_of_attributes: attributes } = product;
  let isBundle = false;
  if (typeof attributes === 'string') {
    isBundle = attributes.indexOf('productType:BUNDLE') > -1;
  } else if (typeof attributes === 'object') {
    isBundle = attributes.productType === 'BUNDLE';
  }
  return isBundle;
};

export const getProductBrandTitle = (brand, primaryBrand) => {
  if (brand === primaryBrand && brand === 'snj') {
    return {
      brandTitle: null, // No Brand Name for on SNJ Site, Only Cross Brand Snj products have brand name
    };
  }
  return {
    brandTitle: PRODUCT_BRAND_NAME_MAP[brand],
  };
};

export const getItemAvailability = () => {
  return {
    itemAvailability: {
      isSoldOut: false,
      message: '',
    },
  };
};

export const getPointsAndRewardsData = ({ isBrierleyPromoEnabled, pointsAndRewardsText }) => {
  if (!isBrierleyPromoEnabled) {
    return { shoudRender: false };
  }
  const pointsAndRewardsLabel = (pointsAndRewardsText && pointsAndRewardsText.split('##')) || '';
  return {
    text1: pointsAndRewardsLabel[0],
    text2: pointsAndRewardsLabel[1],
    text3: pointsAndRewardsLabel[2],
    shoudRender: true,
  };
};

export const getPlpProductBrand = (tileData, defaultBrand) => {
  const attributes = getPLPProductAttributes();
  const primaryBrand = extractAttributeValue(tileData, attributes.primaryBrand);
  return primaryBrand ? primaryBrand?.toLowerCase() : defaultBrand;
};

export const getIsLicensed = (tileData) => {
  const attributes = getPLPProductAttributes();
  const isLicensed = extractAttributeValue(tileData, attributes.isLicensed);
  return parseBoolean(isLicensed);
};

export const getIsBigIdeaLicensedProductBrand = (tileData) => {
  const attributes = getPLPProductAttributes();
  return extractAttributeValue(tileData, attributes.bigIdeaLicensedProductBrand);
};

export const getTCPStyleType = (tileData) => {
  const attributes = getPLPProductAttributes();
  return extractAttributeValue(tileData, attributes.styleType);
};

export const getCustomizationType = (tileData) => {
  return extractAttributeValue(tileData, 'customizationType');
};

export const getVariantDetails = (tileData) => {
  return extractAttributeValue(tileData, 'variantDetails');
};

export const getTCPStyleQty = (tileData) => {
  const attributes = getPLPProductAttributes();
  return extractAttributeValue(tileData, attributes.styleQty);
};

export const getTCPProductIndStore = (tileData) => {
  const attributes = getPLPProductAttributes();
  return extractAttributeValue(tileData, attributes.clearance);
};

export const getTCPWebOnlyFlagStore = (tileData) => {
  const attributes = getPLPProductAttributes();
  return extractAttributeValue(tileData, attributes.onlineOnly);
};

export const getParsedVariantDetails = (variantDetails) => {
  if (!variantDetails) {
    return null;
  }
  try {
    const replacedVariantDetails = variantDetails.replace(/'/g, '"');
    return JSON.parse(replacedVariantDetails);
  } catch (err) {
    return null;
  }
};

export const getAssetHost = (brand, { assetHostGYM, assetHostSNJ, assetHostTCP, assetHostPJP }) => {
  const assetHostMap = {
    tcp: assetHostTCP,
    gym: assetHostGYM,
    snj: assetHostSNJ,
    pjp: assetHostPJP,
  };
  return assetHostMap[brand];
};

export const getProductAssetPath = (
  brand,
  { productAssetPathGYM, productAssetPathSNJ, productAssetPathTCP, productAssetPathPJP }
) => {
  const assetPathMap = {
    tcp: productAssetPathTCP,
    gym: productAssetPathGYM,
    snj: productAssetPathSNJ,
    pjp: productAssetPathPJP,
  };
  return assetPathMap[brand];
};

export const getImageAssetConfig = (brand, apiConfig) => {
  return {
    assetHost: getAssetHost(brand, apiConfig),
    assetPath: getProductAssetPath(brand, apiConfig),
  };
};

export const getProductDataForPdp = ({
  topBadge,
  styleTypeQty,
  primaryBrand,
  tileData,
  productImageUrl,
  isShortImage,
  downloadedImage,
  merchantTag,
  isBundle,
  promotionsData,
  TCPSwatches,
  fromCart = false,
  imageConfigWithoutDPR = '',
}) => {
  const {
    auxdescription,
    TCPBazaarVoiceRating,
    TCPBazaarVoiceReviewCount,
    is_hard_mark_enable: hardMarkDown,
    products = [],
    low_offer_price: lowOfferPrice,
    high_offer_price: highOfferPrice,
    low_list_price: lowListPrice,
    high_list_price: highListPrice,
    TCPPrimaryCategory,
    TCPLoyaltyPromotionTextUSStore: promotionalMessage,
    tcp_promotion_id: TCPPromotionID,
    tcp_promo_price: TCPPromotionPrice,
    variantTotal,
    zoneOneBadgesArray,
    store_specials: storeSpecials,
    dynamicBadgeOverlayQty = '',
    tcpStyleType,
    TCPColor,
  } = tileData;
  const attributes = getPLPProductAttributes();
  const styleQty = styleTypeQty && styleTypeQty[attributes?.styleQty];
  let styleType = styleTypeQty && `${styleTypeQty[attributes?.styleType]}`;
  let imageUrl;
  if (!fromCart) {
    const imgArr = productImageUrl?.split('/');
    imageUrl = imgArr ? imgArr.slice(imgArr.length - 2).join('/') : '';
  } else {
    styleType = tcpStyleType;
    imageUrl = productImageUrl || '';
  }

  const { categoryData = '|' } = tileData;
  const [catId] = categoryData?.split('|');
  const categoryId = catId?.trim();
  return {
    categoryId,
    uniqueId: tileData?.uniqueId,
    name: tileData?.product_name,
    downloadedImage,
    colorFitsSizesMap: [],
    basicImageUrl: imageUrl,
    imageConfigWithoutDPR,
    imagesByColor: {
      [auxdescription]: {
        basicImageUrl: imageUrl,
        extraImages: [
          {
            isShortImage,
            isOnModalImage: false,
            iconSizeImageUrl: imageUrl,
            listingSizeImageUrl: imageUrl,
            regularSizeImageUrl: imageUrl,
            bigSizeImageUrl: imageUrl,
            superSizeImageUrl: imageUrl,
          },
        ],
      },
    },
    listPrice: tileData?.min_list_price,
    offerPrice: tileData?.min_offer_price,
    priceRange: {
      lowOfferPrice,
      highOfferPrice,
      lowListPrice,
      highListPrice,
    },
    isGiftCard: false,
    tcpStyleQty: styleQty,
    tcpStyleType: styleType,
    reviewsCount: TCPBazaarVoiceReviewCount,
    ratings: TCPBazaarVoiceRating,
    unbxdReviewsCount: TCPBazaarVoiceReviewCount,
    unbxdRatings: TCPBazaarVoiceRating,
    plpTopBadge: topBadge,
    primaryBrand,
    hardMarkDown,
    auxdescription,
    merchantTag,
    isBundleProduct: isBundle,
    promotionsData,
    TCPSwatches,
    bundleProductsCount: products,
    lowOfferPrice,
    highOfferPrice,
    lowListPrice,
    highListPrice,
    TCPPrimaryCategory,
    promotionalMessage,
    TCPPromotionID,
    TCPPromotionPrice,
    variantTotal,
    zoneOneBadgesArray,
    storeSpecials,
    dynamicBadgeOverlayQty,
    TCPColor,
    isLicensed: getIsLicensed(tileData),
    isBigIdeaLicensedProductBrand: getIsBigIdeaLicensedProductBrand(tileData),
  };
};

export const extractBaseUrl = (str) => {
  try {
    const { protocol, hostname } = new URL(str);
    return `${protocol}//${hostname}`;
  } catch (e) {
    return str;
  }
};

export const getImageUrl = (imageUrl) => {
  if (!imageUrl) {
    return '';
  }
  const imageUrlArr = imageUrl.split('/');
  return imageUrlArr.slice(imageUrlArr.length - 2).join('/');
};

export const getPayloadForOneClickATC = ({
  tileData,
  topBadge,
  brand,
  imageUrl,
  TCPStyleType,
  parsedVariantDetails,
  cd2,
  isSLPTile,
}) => {
  const {
    auxdescription,
    TCPColor,
    product_name: productName,
    giftcard,
    productid: productId,
    prodpartno: prodPartNo,
    seo_token: seoToken,
    min_list_price: minListPrice,
    min_offer_price: minOfferPrice,
    is_hard_mark_enable: hardMarkDown,
  } = tileData;
  const { UPC_ID, size } = parsedVariantDetails;
  const bossDisabledFlags = {
    bossProductDisabled:
      extractAttributeValue(tileData, getProductAttributes().bossProductDisabled) || 0,
    bossCategoryDisabled:
      extractAttributeValue(tileData, getProductAttributes().bossCategoryDisabled) || 0,
  };
  const isGiftCard = !!giftcard;
  return {
    isGiftCard,
    productName,
    skuInfo: {
      imageUrl: getImageUrl(imageUrl),
      color: { name: isGiftCard ? productName : auxdescription || TCPColor },
      variantId: UPC_ID,
      productId,
      seoToken,
      size,
      fit: null,
      TCPStyleType,
      TCPStyleQTY: getTCPStyleQty(tileData),
      listPrice: parseFloat(minListPrice) || parseFloat(minOfferPrice) || 0,
      offerPrice: parseFloat(minOfferPrice) || 0,
      TCPWebOnlyFlagStore: getTCPWebOnlyFlagStore(tileData),
      TCPProductIndStore: getTCPProductIndStore(tileData),
      prodPartNo,
    },
    fromPage: isSLPTile ? 'search' : 'PLP',
    originPage: isSLPTile ? 'slp' : 'plp',
    brand: brand && brand.toUpperCase(),
    quantity: 1,
    isOnlineExclusive: topBadge || null,
    bossDisabledFlags,
    hardMarkDown,
    cd2,
  };
};

const trackOneClickAtcJourney = (tileData, cd2) => {
  if (cd2) {
    const key = 'oneClickAtcJourney';
    const prodPartNo = tileData?.prodpartno;
    const sessionValue = JSON.parse(getSessionStorage(key));
    const stringifiedSV = JSON.stringify({
      ...sessionValue,
      [prodPartNo]: cd2,
    });
    setSessionStorage({ key, value: stringifiedSV });
  }
  return null;
};

const formatPayloadData = (payload, tileData, isSLPTile) => {
  const currency = getAPIConfig()?.currency;
  return {
    id: tileData?.style_partno,
    CurrCurrency: currency,
    brand: tileData?.brand,
    cartPrice: tileData?.cartPrice,
    category: tileData?.categoryData,
    categoryId: tileData?.categoryData,
    colorId: tileData?.prodpartno,
    dimension2: `${isSLPTile ? 'search' : 'browse'}|one click atc`,
    fromPageName: isSLPTile ? 'search' : 'PLP',
    mpackPageType: tileData?.mpackPageType,
    mpackValue: tileData?.mpackValue,
    name: payload?.productName,
    price: tileData?.low_offer_price,
    prodColor: tileData?.skuInfo?.color?.name,
    quantity: tileData?.quantity,
    productFeatures: tileData?.product_short_description,
    listPrice: tileData?.min_list_price,
  };
};

export const triggerOneClickATC = (args) => {
  const {
    tileData,
    isOneClickATCEnabled,
    isBopisFilterOn,
    topBadge,
    brand,
    imageUrl,
    addToBagEcom,
    isSLPTile,
  } = args;
  if (isOneClickATCEnabled && !isBopisFilterOn && !isShopThisStoreModeOn()) {
    try {
      const TCPStyleType = getTCPStyleType(tileData);
      const customizationType = getCustomizationType(tileData);
      const variantDetails = getVariantDetails(tileData);
      let parsedVariantDetails;
      if (variantDetails) {
        parsedVariantDetails = getParsedVariantDetails(variantDetails);
      }

      if (parsedVariantDetails && TCPStyleType !== '0007' && customizationType !== 'mandatory') {
        const cd2 = `${isSLPTile ? 'search' : 'browse'}|one click atc`;
        const fromAtc = true;
        trackOneClickAtcJourney(tileData, cd2);
        const payload = getPayloadForOneClickATC({
          tileData,
          topBadge,
          brand,
          imageUrl,
          TCPStyleType,
          parsedVariantDetails,
          cd2,
          isSLPTile,
        });
        payload.fromAtc = fromAtc;
        const product = formatPayloadData(payload, tileData, isSLPTile);
        payload.tileData = product;
        addToBagEcom(payload);
        return true;
      }
    } catch (err) {
      logger.error({
        error: err,
        extraData: {
          title: 'An error occurred while triggering one click ATC functionality',
          componentName: 'plpTileCommonHelpers.js',
          methodName: 'triggerOneClickATC',
          args,
        },
      });
      return false;
    }
  }
  return false;
};
